'use client'
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'

/** Same-origin proxy (sanitizes URLs, limits, introspection). Default in production. */
const LOCAL_GRAPHQL_PROXY_URI = '/api/graphql'
const EXTERNAL_GRAPHQL_URL = process.env.NEXT_PUBLIC_GRAPHQL_URL

/**
 * Use `/api/graphql` in production unless explicitly opting into the upstream URL (e.g. local
 * debugging). If `NEXT_PUBLIC_GRAPHQL_URL` points at threatlabz.zscaler.com, browser traffic
 * bypasses the proxy and CMS URLs are not rewritten.
 */
const useDirectGraphqlOrigin =
  process.env.NEXT_PUBLIC_GRAPHQL_USE_DIRECT_ORIGIN?.trim() === 'true'

const API_URI =
  process.env.NODE_ENV === 'development'
    ? LOCAL_GRAPHQL_PROXY_URI
    : useDirectGraphqlOrigin && EXTERNAL_GRAPHQL_URL
      ? EXTERNAL_GRAPHQL_URL
      : LOCAL_GRAPHQL_PROXY_URI

const link = new HttpLink({
  uri: API_URI,
})

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
})

export { client, ApolloProvider }
